import React from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import GatsbyImage from 'gatsby-image'
import MaterialCard, { CardMedia } from '@material-ui/core/Card'

const styles = (theme) => ({
  wrapper: {
    border: `1px solid ${theme.palette.borders.cloudier}`,
    boxShadow: 'none',
  },
  caption: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
  },
  mentions: {
    display: 'flex',
    alignItems: 'center',
  },
})

const SimpleCard = ({
  classes,
  height = 300,
  thumbnail,
  gatsbySizes,
  gatsbyResolutions,
  caption,
  title,
  meta,
}) => {
  let imageComponent = null

  if (!gatsbySizes && thumbnail) {
    imageComponent = (
      <CardMedia
        component="img"
        src={thumbnail}
        style={{ height: height * 0.7 }}
      />
    )
  } else if (gatsbySizes && !thumbnail) {
    imageComponent = (
      <GatsbyImage
        style={{ height: height * 0.7 }}
        // backgroundColor={theme.palette.primary.light}
        sizes={gatsbySizes}
        alt={caption}
        title={caption}
      />
    )
  } else if (gatsbyResolutions) {
    imageComponent = (
      <GatsbyImage
        style={{ height: height * 0.7 }}
        resolutions={gatsbyResolutions}
        alt={title}
        title={title}
      />
    )
  }

  return (
    <MaterialCard style={{ height }} className={classes.wrapper} square>
      {imageComponent}
      <Typography
        classes={{ root: classes.caption }}
        style={{ height: height * 0.1 }}
        variant="subheading"
      >
        {caption}
      </Typography>
      <div className={classes.mentions} style={{ height: height * 0.15 }}>
        <Typography variant="caption" align="center" style={{ width: '100%' }}>
          {meta}
        </Typography>
      </div>
    </MaterialCard>
  )
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired,
  height: PropTypes.number,
  thumbnail: PropTypes.string,
  gatsbySizes: PropTypes.object,
  gatsbyResolutions: PropTypes.object,
  caption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.object,
  ]),
  title: PropTypes.string,
  meta: PropTypes.node,
}

// prettier-ignore
export default compose(
  withStyles(styles)
)(SimpleCard)



// WEBPACK FOOTER //
// ./src/components/SimpleCard.js